/**
 * One line saying where a session's step stands against its track (build contract
 * §2.4a: inheritance is inspectable at the point of use). Nothing is drawn for a
 * step the track left open: the session simply sets it.
 */
import { Lock, CornerDownRight } from 'lucide-react';
import type { StepResolution } from '../../../lib/sessionStepInheritance';

export function TrackStepNote({ step }: { step: StepResolution | null | undefined }) {
  if (!step || step.disposition === 'unset') return null;
  const Icon = step.disposition === 'locked' ? Lock : CornerDownRight;
  return (
    <p
      data-testid={`track-step-note-${step.step}`}
      className="flex items-center gap-1.5 text-xs text-[var(--text-sec)]"
    >
      <Icon size={12} className="shrink-0" aria-hidden />
      {step.reason}
    </p>
  );
}
